import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    Text,
    Button,
    HStack,
} from '@chakra-ui/react';

export interface InvoiceChangeShopLocationModalProps {
    isOpen: boolean;
    onClose: () => void;
    isLoading: boolean;
    currentLocationLabel: string;
    nextLocationLabel: string;
    onConfirm: () => void;
}

const InvoiceChangeShopLocationModal = ({
    isOpen,
    onClose,
    isLoading,
    currentLocationLabel,
    nextLocationLabel,
    onConfirm,
}: InvoiceChangeShopLocationModalProps) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="md">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader fontSize="xl" fontWeight="bold" color="gray.900">
                    Change shop location?
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={4}>
                    <Text fontSize="md" color="gray.600" mb={3}>
                        Are you sure you want to change the shop location from{' '}
                        <strong>{currentLocationLabel || '—'}</strong> to{' '}
                        <strong>{nextLocationLabel || '—'}</strong>?
                    </Text>
                    <Text fontSize="md" color="gray.600">
                        Markup and discount rules that depend on shop state will be re-evaluated, and the invoice will
                        re-reconcile with the new location.
                    </Text>
                </ModalBody>
                <ModalFooter>
                    <HStack spacing={3}>
                        <Button size="action" variant="outlineGray" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button size="action"
                            bg="#0071E3"
                            color="white"
                            _hover={{ bg: '#3544a0' }} onClick={onConfirm} isLoading={isLoading} loadingText="Updating…">
                            Change location and reconcile
                        </Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default InvoiceChangeShopLocationModal;
